module.exports = __webpack_public_path__ + "img/mobile-catch-assets-01.fb68de63.png";